import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import chat_bg from "../assets/images/chat_bg.gif";
import SvgContent from "../components/svgcontent.jsx";

function formatTimeIST(datetime) {
  const date = new Date(datetime);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
}

function Chatbot({ ShowChatbotTab }) {

  const session_id = localStorage.getItem("session_id");

  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const chatBodyRef = useRef(null);

  // auto scroll
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [messages, loading]);



  const handleSend = async () => {

    if (!query.trim()) return;

    const userMessage = query;

    const userMsgObj = {
      isUser: true,
      message: userMessage,
      time: formatTimeIST(new Date()),
    };

    setMessages((msgs) => [...msgs, userMsgObj]);

    setQuery("");
    setLoading(true);

    try {

      const response = await fetch(
        "https://n8n.boovinzxfs.me/webhook/vpbot1",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          // IMPORTANT: correct body format for n8n
          body: JSON.stringify({
            session_id,
            query: {
              text: userMessage,
            },
          }),
        }
      );

      const data = await response.json();

      let botMessage = "Sorry, I did not understand that.";

      if (data?.data) {

        const obj = data.data;

        // dynamic response formatting
        botMessage = Object.entries(obj)
          .map(([key, value]) => `${key}: ${value}`)
          .join("\n");

      }

      setMessages((msgs) => [
        ...msgs,
        {
          isUser: false,
          message: botMessage,
          time: formatTimeIST(new Date()),
        },
      ]);

    } catch (error) {

      console.error("Chatbot error:", error);

      setMessages((msgs) => [
        ...msgs,
        {
          isUser: false,
          message: "Server error. Please try again.",
          time: formatTimeIST(new Date()),
        },
      ]);

    } finally {
      setLoading(false);
    }

  };



  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" && !loading) {
      e.preventDefault();
      handleSend();
    }
  };



  const hasUserMessage = messages.some((msg) => msg.isUser);



  return (
    <div className="chatbot-main-st">

      <div className="chatbot-container-st">

        <div className="chatbot-head-st">
          <h5 className="mb-0 fw-semibold">Chatbot</h5>

          <button
            type="button"
            style={{
              fontSize: "25px",
              cursor: "pointer",
              background: "none",
              border: "none",
              padding: 0,
              lineHeight: 1,
            }}
            aria-label="Close chatbot"
            onClick={ShowChatbotTab}
          >
            &times;
          </button>
        </div>



        <div className="chatbot-body-st" ref={chatBodyRef}>

          {!hasUserMessage && (
            <>
              <h6 className="mb-0 fw-semibold">Welcome!!</h6>
              <p style={{ color: "rgb(157 154 154)" }}>
                Ask me anything...
              </p>

              <img
                src={chat_bg}
                alt="chat_bg"
                className="img-init-bodyst"
              />
            </>
          )}



          <div>

            {messages.map((msg, idx) => (
              <div
                key={msg.time + idx}
                className={`chat-row ${msg.isUser ? "user" : "bot"}`}
                style={{ marginBottom: "8px" }}
              >

                <div
                  className={`chat-bubble ${
                    msg.isUser ? "user" : "bot"
                  }`}
                >

                  <pre className="mb-0">
                    {msg.message}
                  </pre>

                  <div
                    style={{
                      fontSize: "0.75em",
                      color: "#000",
                      textAlign: "right",
                    }}
                  >
                    {msg.time}
                  </div>

                </div>

              </div>
            ))}



            {loading && (
              <div style={{ textAlign: "left", margin: "10px 0" }}>
                <div
                  style={{
                    display: "inline-block",
                    padding: "10px 15px",
                    borderRadius: "20px",
                    background: "#f1f0f0",
                    color: "#000",
                    maxWidth: "70%",
                  }}
                >
                  Typing...
                </div>
              </div>
            )}

          </div>
        </div>



        <div className="chatbot-foot-st">

          <div className="d-flex align-items-center gap-2 w-100 inner-footcont-st">

            <textarea
              className="inner-footcont-textarea"
              placeholder="Type here..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleInputKeyDown}
              disabled={loading}
            />

            <button
              type="button"
              onClick={handleSend}
              disabled={loading || !query.trim()}
              className="send-btn-st"
            >
              <SvgContent svg_name="send_msg" />
            </button>

          </div>

        </div>

      </div>
    </div>
  );
}

Chatbot.propTypes = {
  ShowChatbotTab: PropTypes.func.isRequired,
};

export default Chatbot;